var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{ref:"ocrCanvas",attrs:{"id":"canvas"}})
}
var staticRenderFns = []

export { render, staticRenderFns }